import { defineApis, define } from '@tiny-type-api/universal';
export const { apis: ecApis } = defineApis({
    '/api/search': {
        GET: {
            request: {
                query: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/products': {
        GET: {
            request: {
                query: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/products/categories': {
        GET: {
            request: {},
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/products/:id': {
        GET: {
            request: {},
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/products/slug/:slug': {
        GET: {
            request: {},
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/users/mine': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/cart': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/cart/batch': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/cart/item/:id': {
        DELETE: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/orders/:id': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/orders/mine': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/user/info': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/user/info/update': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/users/profile': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/upload/contact': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/shipping/info': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/stripe/create-checkout-session': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/stripe/publishable-key': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/role': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/users/all': {
        GET: {
            request: {
                headers: define(),
                query: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/users/:id': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        PUT: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/image': {
        POST: {
            request: {
                headers: define(),
                form: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/image/:productId': {
        DELETE: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/products': {
        GET: {
            request: {
                headers: define(),
                query: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        POST: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/products/:id': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        DELETE: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/orders/summary': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/orders/all': {
        GET: {
            request: {
                headers: define(),
                query: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/orders/:id': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        DELETE: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/orders/:id/deliver': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/orders/:id/paymentstatusunpaid': {
        PUT: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/orders/:id/paymentstatuspaid': {
        PUT: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/categories': {
        POST: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/categories/:id': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        PUT: {
            request: {
                headers: define(),
                body: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        },
        DELETE: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/categories/all': {
        GET: {
            request: {
                headers: define(),
                query: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/admin/categories/allupaged': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/bcp/organization/list': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    },
    '/api/bcp/organization/connected/places': {
        GET: {
            request: {
                headers: define()
            },
            response: {
                200: {
                    body: define()
                }
            }
        }
    }
});
//# sourceMappingURL=ecUniversal.js.map